import { SilentTypeConversionError } from '../../../lib/error';
import AbstractColumnHelper from '../column.interface';
import { normalizeHexColour } from '../utils/colour';
export class ColourHelper extends AbstractColumnHelper {
    constructor() {
        super(...arguments);
        this.columnDefaultMeta = {
            defaultColor: '#FFFFFF',
            displayFormat: 'swatch_hex', // 'swatch_hex' | 'swatch_only' | 'hex_only'
            swatchStyle: 'circle', // 'circle' | 'square'
            swatchSize: 'medium', // 'small' | 'medium' | 'large'
        };
    }
    /**
     * Serialise a user-supplied value for storage.
     *
     * During bulk paste or search-query serialisation, invalid values are
     * silently dropped (returns `null`).  In all other contexts an invalid
     * value throws a {@link SilentTypeConversionError} so the caller can
     * surface an appropriate message.
     */
    serializeValue(value, params) {
        if (!value)
            return null;
        const normalized = normalizeHexColour(value);
        if (!normalized) {
            if (params.isMultipleCellPaste || params.serializeSearchQuery) {
                return null;
            }
            else {
                throw new SilentTypeConversionError();
            }
        }
        return normalized;
    }
    /** Parse a stored value for display. Returns `null` for invalid values. */
    parseValue(value) {
        return normalizeHexColour(value);
    }
    /** Return a plain-text representation suitable for export / clipboard. */
    parsePlainCellValue(value, _params) {
        return normalizeHexColour(value) || '';
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sb3VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb2x1bW5IZWxwZXIvY29sdW1ucy9Db2xvdXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLHlCQUF5QixFQUFFLE1BQU0sYUFBYSxDQUFDO0FBQ3hELE9BQU8sb0JBRU4sTUFBTSxxQkFBcUIsQ0FBQztBQUM3QixPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUVyRCxNQUFNLE9BQU8sWUFBYSxTQUFRLG9CQUFvQjtJQUF0RDs7UUFDRSxzQkFBaUIsR0FBRztZQUNsQixZQUFZLEVBQUUsU0FBUztZQUN2QixhQUFhLEVBQUUsWUFBWSxFQUFFLDRDQUE0QztZQUN6RSxXQUFXLEVBQUUsUUFBUSxFQUFFLHNCQUFzQjtZQUM3QyxVQUFVLEVBQUUsUUFBUSxFQUFFLCtCQUErQjtTQUN0RCxDQUFDO0lBeUNKLENBQUM7SUF2Q0M7Ozs7Ozs7T0FPRztJQUNILGNBQWMsQ0FDWixLQUFVLEVBQ1YsTUFBMkM7UUFFM0MsSUFBSSxDQUFDLEtBQUs7WUFBRSxPQUFPLElBQUksQ0FBQztRQUV4QixNQUFNLFVBQVUsR0FBRyxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUU3QyxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7WUFDaEIsSUFBSSxNQUFNLENBQUMsbUJBQW1CLElBQUksTUFBTSxDQUFDLG9CQUFvQixFQUFFLENBQUM7Z0JBQzlELE9BQU8sSUFBSSxDQUFDO1lBQ2QsQ0FBQztpQkFBTSxDQUFDO2dCQUNOLE1BQU0sSUFBSSx5QkFBeUIsRUFBRSxDQUFDO1lBQ3hDLENBQUM7UUFDSCxDQUFDO1FBRUQsT0FBTyxVQUFVLENBQUM7SUFDcEIsQ0FBQztJQUVELDJFQUEyRTtJQUMzRSxVQUFVLENBQUMsS0FBVTtRQUNuQixPQUFPLGtCQUFrQixDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ25DLENBQUM7SUFFRCwwRUFBMEU7SUFDMUUsbUJBQW1CLENBQ2pCLEtBQVUsRUFDVixPQUE0QztRQUU1QyxPQUFPLGtCQUFrQixDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUN6QyxDQUFDO0NBQ0YifQ==